/**
 * TooltipComponent
 *
 */

import React from 'react'

import { Box, Theme, Typography } from '@mui/material'
import InfoIcon from '@mui/icons-material/Info'

import TooltipComponent from './TooltipComponent'
import { makeStyles } from '@mui/styles'

interface Props {
  description?: string
  label: string
  placement?: 'bottom-end'
    | 'bottom-start'
    | 'bottom'
    | 'left-end'
    | 'left-start'
    | 'left'
    | 'right-end'
    | 'right-start'
    | 'right'
    | 'top-end'
    | 'top-start'
    | 'top'
}

const useStyles = makeStyles((theme: Theme) => ({
  tooltipIcon: {
    cursor: 'pointer',
    margin: '0 0 0 5px',
    color: 'rgb(0,0,0,0.6)',
    width: '16px',
    height: '16px',
  },
}))

const LabelWithTooltipComponent: React.FC<Props> = (props) => {
  const classes = useStyles()

  return (
    <>
      <Box sx={{ display: 'flex', flexWrap: 'nowrap' }}>
        <Typography sx={{ fontSize: '12px', color: 'rgb(0,0,0,0.6)' }} variant='body2'>{props.label}</Typography>
        {props.description &&
          <TooltipComponent
            title={props.description || 'hallo'}
            element={<InfoIcon className={classes.tooltipIcon} />}
          />}
      </Box>
    </>
  )
}
export default LabelWithTooltipComponent
